import type * as React from 'react';
import type { FC } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { Loader } from '@crehana/ui';
import { useUITheme } from '@crehana/web';

const DegreeSkeleton: FC<
  React.PropsWithChildren<{ 'data-testid'?: string }>
> = ({ 'data-testid': dataTestId }) => {
  const { isDark } = useUITheme();

  return (
    <div
      className={`flex items-center justify-center py-80 ${
        isDark ? 'bg-base-lighter-8' : 'bg-white'
      }`}
      data-testid={dataTestId}
    >
      <Loader white={isDark} />
    </div>
  );
};

export default DegreeSkeleton;
